<div class="pages-body notfound-page p-d-flex p-flex-column">
    <div class="p-as-center p-mt-auto p-mb-auto p-shadow-12">
        <div class="pages-panel card p-d-flex p-flex-column custom-color">
            <div class="pages-header p-px-3 p-py-1">
                <h2>НИЈЕ ПРОНАЂЕНО</h2>
            </div>
            <div class="card p-mt-3 p-px-6">
                <img src="assets/images/background/not-found.png" alt="" />
            </div>
            <div class="pages-detail p-pb-6">Затражена странице не постоји</div>
            <button
                [label]="'Повратак на почетну страницу'"
                [routerLink]="'/pozorisni-muzej/izlozbe/pocetna'"
                type="button"
                pButton
                pRipple
            ></button>
        </div>
    </div>
</div>
